module.exports = __webpack_public_path__ + "static/banner-bg-3a8a6d5ceab43de597f26ca167a80fe4.png";